import { createApp, type ComponentPublicInstance } from 'vue';
import { createPinia } from 'pinia';
import {
    Quasar,
    Loading,
    Screen,
    Dialog,
    Notify,
} from 'quasar';

import '@quasar/extras/material-icons/material-icons.css';
import '@quasar/extras/material-icons-outlined/material-icons-outlined.css';
import '@quasar/extras/material-symbols-outlined/material-symbols-outlined.css';
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css';
import 'quasar/dist/quasar.css';
import '@fontsource/ubuntu/400.css';
import '@fontsource/ubuntu/500.css';
import '@fontsource/ubuntu/700.css';
import '@/assets/base.scss';

import App from './App.vue';
import router from './router';
import { GlobalErrorHandler } from './services/GlobalErrorHandler';

const globalErrorHandler = new GlobalErrorHandler();

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(Quasar, {
    plugins: {
        Notify,
        Loading,
        Screen,
        Dialog,
    },
});

app.config.errorHandler = (err: unknown, instance: ComponentPublicInstance|null, info: string) => {
    globalErrorHandler.vueErrorHandler(err, instance, info);
};

app.mount('#app');
